module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/index.js
 ** module id = 292
 ** module chunks = 0
 **/